var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgPaperPlane(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M4.122 12.235l21-12c.469-.282 1.125-.282 1.594.046.468.328.703.891.61 1.453l-3 19.5c-.142.938-1.173 1.547-2.063 1.172L16.45 19.97l-2.906 3.515a1.523 1.523 0 01-1.172.516 1.48 1.48 0 01-1.5-1.5v-4.875l-6.61-2.719c-1.124-.468-1.218-2.062-.14-2.671zm2.437 1.171l5.766 2.391-.047-.047L22.544 4.266l-15.985 9.14zm15.704 6.563l2.203-14.485-10.032 11.204 7.829 3.28z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgPaperPlane);
export default ForwardRef;
